export default __webpack_public_path__ + "static/media/Reject.662695cb.svg";